import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Layout, Dashboard, Content, /* Marketplace, */ /* Products, */ /* Partners, */ Users, Plans, Login } from './pages/index.js'
import KnowledgeBase from './pages/admin/KnowledgeBasePage'
import LibraryDocs from './pages/admin/LibraryPage'
import Metrics from './pages/Metrics'
import ChatModels from './pages/ChatModels'
import { AuthProvider } from './contexts/AuthContext'
import { usePermissions } from './hooks/usePermissions'
import { Toaster } from './components/ui/sonner'

function AppContent() {
  const { loading, isAuthenticated, isAdmin, isCreator, isGod } = usePermissions()
  const isContentOnlyCreator = isAuthenticated && isCreator() && !isAdmin() && !isGod()
  const isAdminOrGod = isAuthenticated && (isAdmin() || isGod())

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        {isContentOnlyCreator ? (
          <Route
            path="/*"
            element={
              <Layout showSidebar={false}>
                <Routes>
                  <Route path="/" element={<Navigate to="/content" replace />} />
                  <Route path="/dashboard" element={<Navigate to="/content" replace />} />
                  <Route path="/metrics" element={<Navigate to="/content" replace />} />
                  <Route path="/users/*" element={<Navigate to="/content" replace />} />
                  <Route path="/plans" element={<Navigate to="/content" replace />} />
                  <Route path="/knowledge" element={<Navigate to="/content" replace />} />
                  <Route path="/library-docs" element={<Navigate to="/content" replace />} />
                  <Route path="/content/*" element={<Content />} />
                  <Route path="*" element={<Navigate to="/content" replace />} />
                </Routes>
              </Layout>
            }
          />
        ) : (
          <Route
            path="/*"
            element={
              isAdminOrGod ? (
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/metrics" element={<Metrics />} />
                    <Route path="/content/*" element={<Content />} />
                    {/* <Route path="/marketplace/*" element={<Marketplace />} /> */}
                    <Route path="/users/*" element={<Users />} />
                    <Route path="/plans" element={<Plans />} />
                    <Route path="/knowledge" element={<KnowledgeBase />} />
                    <Route path="/library-docs" element={<LibraryDocs />} />
                    <Route path="/chat-models" element={<ChatModels />} />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        )}
      </Routes>
      <Toaster />
    </Router>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App